"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createPcg32 = exports.randomList = exports.randomInt = exports.prevState = exports.nextState = exports.stepState = void 0;
const bitwise_1 = require("./bitwise");
const defaults_1 = require("./defaults");
const types_1 = require("./types");
const createPcg_1 = __importDefault(require("./createPcg"));
var createPcg_2 = require("./createPcg");
Object.defineProperty(exports, "stepState", { enumerable: true, get: function () { return createPcg_2.stepState; } });
Object.defineProperty(exports, "nextState", { enumerable: true, get: function () { return createPcg_2.nextState; } });
Object.defineProperty(exports, "prevState", { enumerable: true, get: function () { return createPcg_2.prevState; } });
Object.defineProperty(exports, "randomInt", { enumerable: true, get: function () { return createPcg_2.randomInt; } });
Object.defineProperty(exports, "randomList", { enumerable: true, get: function () { return createPcg_2.randomList; } });
exports.createPcg32 = (0, createPcg_1.default)({
    numOutputBits: 32,
    multiplier: defaults_1.pcgDefaultMultiplier64,
    increment: defaults_1.pcgDefaultIncrement64,
    outputFns: {
        [types_1.OutputFnType.XSH_RR]: (state) => (0, bitwise_1.ror32)(state.shru(59).toInt(), state.shru(18).xor(state).shru(27).toInt()),
        [types_1.OutputFnType.XSH_RS]: (state) => state.shru(22).xor(state).shru(state.shru(61).add(22)).toInt(),
        [types_1.OutputFnType.XSL_RR]: (state) => (0, bitwise_1.ror32)(state.shru(59).toInt(), state.shru(32).xor(state).toInt()),
        // [OutputFnType.XSL_RR_RR]: (state: Long): number => {
        //   const high = state.shru(32)
        //   const newlow = ror32(state.shru(59).toInt(), high.xor(state).toInt())
        //   return new Long(ror32(new Long(newlow).and(32).toInt(), high.toInt())).shl(32).or(newlow).toInt()
        // },
        [types_1.OutputFnType.RXS_M_XS]: (state) => {
            const word = state.shru(13).add(3).xor(state).mul(62169);
            return word.shru(11).xor(word).toInt();
        },
    },
});
